export default "__VITE_ASSET__25Q9H7Ua__"